import { ConsentFormSection } from 'src/pages/MainPage/components/ConsentForm/ConsentFormSection';
import Logo from '@tenant/components/Logo';
import { useSetDocumentTitle } from 'src/common/hooks/useSetDocumentTitle';
import { useStartProcess } from 'src/pages/MainPage/useStartProcess';
import MainPageAlert from '@tenant/components/MainPageAlert';
import MainPageStepsList from '@tenant/components/MainPageStepsList';
import MainPageLayout from '@tenant/layouts/MainPageLayout';

const items: MessageId[] = [
  'main.steps.1',
  'main.steps.2',
  'main.steps.3',
  'main.steps.4',
];

const MainPage = () => {
  useSetDocumentTitle('Aisgateway- Start');
  useStartProcess();

  return (
    <MainPageLayout
      tenantLogo={<Logo />}
      stepsList={<MainPageStepsList items={items} />}
      alert={<MainPageAlert />}
      consentForm={<ConsentFormSection />}
    />
  );
};

export default MainPage;
